import {create} from 'zustand';
import {EvaluationsService} from '../../api/generated/EvaluationsService';
import {EvaluationDetailDto} from '../../api/generated/index.defs';

type EvaluationStoreVariables = {
  data: EvaluationDetailDto | null;
  loading: boolean;
};

type EvaluationStoreFunctions = {
  fetch: (jobId: number) => Promise<void>;
  clear: () => void;
};

type EvaluationStore = EvaluationStoreFunctions & EvaluationStoreVariables;

const DEFAULTS: EvaluationStoreVariables = {
  data: null,
  loading: false,
};

export const useEvaluationStore = create<EvaluationStore>((set) => ({
  ...DEFAULTS,
  fetch: async (jobId: number) => {
    set({loading: true});
    const {data} = await EvaluationsService.getByJobId({
      jobId: jobId,
    });
    set({data: data, loading: false});
  },
  clear: () => set({data: null}),
}));
